import React from "react";
import Title from "../title";
import { BsFilter } from "react-icons/bs"
import {
  Container,
  Header,
} from "./styles"
import Loading from '../loading';
import { useTheme } from "styled-components";
interface IProps {
  title?: string,
  actionButtons?: {
    icon: JSX.Element;
    action: () => void
  }[];
  filterButton?: boolean;
  handleFilterButton?: () => void;
  loading?: boolean;
  gridArea?: string;
  children: React.ReactNode
  scroll?: boolean;
  ocorrencia?: boolean;
}

const BoxContainer: React.FC<IProps> = ({ children, title, actionButtons, filterButton, handleFilterButton, loading, gridArea, scroll, ocorrencia }) => {
  const theme = useTheme();

  return (
    <Container ocorrencia={ocorrencia} scroll={scroll} gridArea={gridArea}>
      <Header>
        <Title className="!text-[rgba(0,0,0,.5)] !font-light">{title}</Title>
        {
          actionButtons?.map(a => {
            return (
              <>
                <a onClick={a.action} href={"#"}>
                  {a.icon}
                </a>
              </>
            )
          })
        }
        {filterButton && <a onClick={handleFilterButton}><BsFilter size={20} /></a>}
      </Header>

      {!loading ? children : <Loading />}

    </Container>
  )
}
export default BoxContainer;